/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelPraticaOperatoreListItemDTO } from '../model/models';
import { PraticaCambioStatoForm } from '../model/models';
import { PraticaOperatoreDetailDTO } from '../model/models';
import { PraticaOperatoreListFilter } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CambioStatoPraticaRequestParams {
    idTipoPratica: string;
    idPratica: string;
    praticaCambioStatoForm: PraticaCambioStatoForm;
}

export interface GetPraticaRequestParams {
    idTipoPratica: string;
    idPratica: string;
}

export interface ListPraticheRequestParams {
    idTipoPratica: string;
    filter: PraticaOperatoreListFilter;
    pageable: Pageable;
}


export interface GestionePraticheServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Cambio stato operatore della pratica (change add-gestione-pratica-actions, Fase 10.g). Body: {nuovo_stato, version, commento?}. Capability GESTIONE richiesta. Precondizioni R1..R6 enforced dal chokepoint state machine. Per transizioni terminali (ACCETTATA/RIFIUTATA) dispatch comunicazioni post-commit. Response codes: 200 success, 400 validation, 403 capability mancante, 404 pratica/cross-tipo, 409 optimistic lock o gate ANPR, 422 transizione non ammessa o R6.
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/stato
* @param requestParameters
     */
    cambioStatoPratica(requestParameters: CambioStatoPraticaRequestParams, extraHttpRequestParams?: any): Observable<PraticaOperatoreDetailDTO>;

    /**
     * Detail form-shaped della pratica. Body: {summary, form_data: {chiave→valore, anagrafica: {...}, nucleo: [...]}, allegati: []}. Cross-bando → 404 con i18n key gestione_pratica_not_found.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}
* @param requestParameters
     */
    getPratica(requestParameters: GetPraticaRequestParams, extraHttpRequestParams?: any): Observable<PraticaOperatoreDetailDTO>;

    /**
     * Lista paginata delle pratiche del bando indicato. Audience SUPERADMIN/OP_COMUNE/OP_PRATICA. Filtri opzionali: stato (multi-select raw, comma-separated), q (exact match su codice_pratica OR CF hash). Sort default timestamp_richiesta DESC, customizzabile via ?sort&#x3D;.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche
* @param requestParameters
     */
    listPratiche(requestParameters: ListPraticheRequestParams, extraHttpRequestParams?: any): Observable<PagedModelPraticaOperatoreListItemDTO>;

}
